const prefix = 'payments-filter__';

export default {
  clearButton: `${prefix}clear-button`,
  planTypeSelect: `${prefix}plan-type-select`,
  paymentStatusSelect: `${prefix}payment-status-select`,
  applyButton: `${prefix}apply-button`
};
